import React from 'react';
import './quantia.css';

/**
 * Tarjeta de métrica/estadística Quantia.
 *
 * Props:
 *  - label:   etiqueta uppercase pequeña
 *  - value:   valor principal (número o string)
 *  - suffix:  sufijo pequeño coloreado (ej. "+", "%", "K")
 *  - trend:   string opcional (ej. "↑ 24% vs año anterior")
 *  - trendDirection: 'up' | 'down' | 'neutral' (default)
 *  - variant: 'light' (default, fondo blanco) | 'purple' (fondo morado)
 */
const StatCard = ({
  label,
  value,
  suffix,
  trend,
  trendDirection = 'neutral',
  variant = 'light',
}) => {
  return (
    <div className={`qa-stat qa-stat--${variant}`}>
      {label && <div className="qa-stat__label">{label}</div>}
      <div className="qa-stat__value">
        {value}
        {suffix && <span className="qa-stat__suffix">{suffix}</span>}
      </div>
      {trend && (
        <div className={`qa-stat__trend qa-stat__trend--${trendDirection}`}>
          {trend}
        </div>
      )}
    </div>
  );
};

export default StatCard;
